import { ButtonHTMLAttributes } from 'react'

import { IconName } from 'ui/components/'

export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  face?: 'primary' | 'danger' | 'secondary' | 'tertiary' | 'inherit white'
  loading?: boolean
  iconLeft?: IconName
  iconRight?: IconName

  'data-qa'?: string
}
